import { ASTERISK, NON_FLOW_MODULES } from "./constants.js";

/**
 * Returns actions permitted for the given module and resource
 * A colsolidated result of actions under "*" as well as actions under {module}{resource} param
 * @param {string} permissions - User's permission object
 * @param {string} module
 * @param {string} resource
 * @returns {string[]} - List of actions permitted
 */
export function getPermissibleActions(
  permissions = {},
  module = "",
  resource = ""
) {
  const allowedActions = [];
  if (!module || !resource) {
    return [];
  }

  if (module in permissions) {
    const _actions = getResourceLevelActions(permissions[module], resource);
    allowedActions.push(..._actions);
  }

  if (!NON_FLOW_MODULES.includes(module) && ASTERISK in permissions) {
    const _actions = getResourceLevelActions(permissions[ASTERISK], resource);
    allowedActions.push(..._actions);
  }

  return allowedActions;
}

/**
 * Returns actions permitted for the resource
 * A colsolidated result of actions under "*" as well as actions under {resource} param
 * @param {string} modulePermissions - permissionObject[module]
 * @param {string} resource
 * @returns {string[]} - List of actions permitted
 */
const getResourceLevelActions = (modulePermissions, resource) => {
  const allowedActions = [];
  if (resource in modulePermissions) {
    const _actions = modulePermissions[resource];
    allowedActions.push(..._actions);
  }
  if (resource !== ASTERISK && ASTERISK in modulePermissions) {
    const _actions = modulePermissions[ASTERISK];
    allowedActions.push(..._actions);
  }

  return allowedActions;
};
